import * as tslib_1 from "tslib";
import { Observable } from "rxjs";
import { RestServiceConstants } from "../../constants/rest-service.constants";
import { RestClient } from "../rest/client/rest.client";
import { ResponseBody } from "../rest/decorators/response-body.decorator";
import { Query } from "../rest/request/params";
import { Headers } from "../rest/decorators/headers.decorator";
import { GET } from "../rest/request/methods";
import { MEGConstants } from "../../constants/meg.constants";
import { DMVConstants } from "../../constants/dmv.constants";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class MEGDataService extends RestClient {
    getConfiguration(appType, entryPointID, token) {
        return;
    }
    getConfigurationResponse(appType, entryPointID, token) {
        this.setDynamicTimeout(DMVConstants.TIMEOUT);
        this.setDynamicUri(MEGConstants.CONFIGURATION_URI);
        return this.getConfiguration(appType, entryPointID, token);
    }
}
MEGDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MEGDataService_Factory() { return new MEGDataService(i0.ɵɵinject(i1.HttpClient)); }, token: MEGDataService, providedIn: "root" });
tslib_1.__decorate([
    Headers({
        Accept: RestServiceConstants.APPLICATION_JSON,
        "content-type": RestServiceConstants.APPLICATION_JSON
    }),
    GET(),
    ResponseBody(),
    tslib_1.__param(0, Query("AppTypeID")),
    tslib_1.__param(1, Query("EntryPointID")),
    tslib_1.__param(2, Query("Token")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Number, String]),
    tslib_1.__metadata("design:returntype", Observable)
], MEGDataService.prototype, "getConfiguration", null);
